// extracted by mini-css-extract-plugin
module.exports = {"tagList":"TagList_tagList__JWW0U","title":"TagList_title__cehgf","tagItem":"TagList_tagItem__3r6Sa"};